import { useCallback, useState } from 'react';

export const ALL_QUESTIONS_REQUIRED_MESSAGE =
  'Please answer all questions before continuing to the next page.';

export function useSurveyRequiredAnswers() {
  const [warning, setWarning] = useState<string | null>(null);

  const dismissWarning = useCallback(() => setWarning(null), []);

  const canProceed = useCallback((allAnswered: boolean, message?: string) => {
    if (!allAnswered) {
      setWarning(message ?? ALL_QUESTIONS_REQUIRED_MESSAGE);
      return false;
    }
    setWarning(null);
    return true;
  }, []);

  return { warning, canProceed, dismissWarning };
}
